import React from 'react'
import PropTypes from 'prop-types'
import 'styles/location-finder.css'
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import Utils from 'common/utils';

const DEBOUNCE_DELAY_MS = 300

const searchText = (text) => { return text }
const searchTextDebounced = AwesomeDebouncePromise(searchText, DEBOUNCE_DELAY_MS);

export default class SearchBarView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchQuery: props.searchQuery
        }
        this.searchInput = null
    }

    componentDidMount() {
        // NOTE: This set-timeout is required since focusing the keyboard messes with the animation of the page.
        // Make sure that the setimeout duration is equal to the animation duration.
        setTimeout(() => {
            if (false === Utils.isNull(this.searchInput)) {
                this.searchInput.focus()
            }
        }, 750)
    }

    async setSearchQuery(evt) {
        this.setState({
            searchQuery: evt.target.value
        })

        // NOTE: Purposefully created global-constants for this to work. Won't work if they're defined here.
        let val = await searchTextDebounced(evt.target.value)
        this.updateQuery(val)
    }

    updateQuery(queryVal) {
        this.props.queryChangedCb(queryVal)
    }

    render() {
        return (
            <input
                ref={(input) => { this.searchInput = input }}
                className="search-input"
                type="search"
                name="search-city"
                onChange={this.setSearchQuery.bind(this)}
                placeholder="Enter city name"
                spellCheck="false"
            />
        )
    }
}

SearchBarView.propTypes = {
    queryChangedCb: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/locationFinder/searchBarView.js